import { call, put, select } from 'redux-saga/effects';
import {
  changeStatusAfterUpdate,
  fetchActivityLogsRequest,
  submitReturnFailure,
  submitReturnSuccess,
} from '../actions';
import { ApiError, ApiResponse } from 'store/api/types';
import { SubmitReturnRequestAction } from '../types';
import { checkResponse } from 'store/utils';

import { submitReturn } from '../api';
import { turnMessageOn } from 'store/app/actions';
import { MessageData } from 'store/app/types';
import { MessageStates } from 'containers/MessageBox';
import { DataLogStatus, SubmissionUpdateField } from 'store/app/enums';
import {
  fetchOrganisationsRequest,
  updateSubmissionLog,
} from 'store/organisation/actions';
import { logoutRequest } from 'store/auth/actions';
import { renderErrorMessage } from 'utils/render-error-message';
import { getVatRunData } from '../selectors';
import { Provider } from 'store/api/enums';
import { submitTifdReportFromReturnSaga } from 'store/tifd/sagas/submitTifdReportSaga';
import i18n from 'i18next';

/* eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types */
export function* submitReturnSaga(action: SubmitReturnRequestAction) {
  const submittedTifd: boolean = yield call(
    submitTifdReportFromReturnSaga,
    action
  );
  if (submittedTifd) return;

  try {
    let err: ApiError | null;
    const { dataLogId, mappingId } = action.payload;
    const response: ApiResponse = yield call(
      submitReturn,
      dataLogId,
      mappingId
    );
    err = checkResponse(response?.responseMessage);
    if (err) throw err;
    const message: MessageData = {
      title: i18n.t('common.success-exclamation'),
      description: response.responseMessage.message,
      type: MessageStates.SUCCESS,
    };
    yield put(turnMessageOn(message));
    yield put(fetchActivityLogsRequest(dataLogId));
    yield put(changeStatusAfterUpdate(DataLogStatus.SUBMITTED));
    //yield put(fetchOrganisationsRequest());

    yield put(submitReturnSuccess());
    yield put(
      updateSubmissionLog(
        mappingId,
        SubmissionUpdateField.STATUS,
        DataLogStatus.SUBMITTED,
        dataLogId
      )
    );

    const vatRunData = yield select(getVatRunData);
    const isProviderGroupSubmission =
      vatRunData?.providerName?.toLowerCase() === Provider.GROUP.toLowerCase();
    if (isProviderGroupSubmission) {
      yield put(fetchOrganisationsRequest());
    }
  } catch (error: any) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(submitReturnFailure());
  }
}
